import React, { useContext } from 'react';
import { Button } from 'antd';
import { Col, Row, Divider } from '@common/components';
import { getNumberPositionSufix } from '@approvals/services/approvals-service';
import {
  generateEmptyStep,
  getKey,
  removeItem,
} from '@approvals/services/approvals-page-drawer-service';
import { ApprovalsEditDrawerListApprovers } from './_approvals-edit-drawer-list-approvers';
import { ApprovalsEditDrawerDeleteButton } from './_approvals-edit-drawer-delete-button';
import { ApprovalDrawerContext } from './approvals-edit-drawer';
import { ApprovalChainStepTemplateType } from '@approvals/graphql';

type Props = {
  steps: ApprovalChainStepTemplateType[];
};

export const ApprovalsEditDrawerListStep = ({ steps }: Props) => {
  const { forceUpdate, preApproved } = useContext(ApprovalDrawerContext);

  function addStep() {
    steps.push(generateEmptyStep());
    forceUpdate();
  }

  function removeStep(id: string, randomKey: string) {
    const stepToDelete = steps.find((step) =>
      id ? id === step.id : randomKey === step.randomKey
    );

    const stepIndex = steps.indexOf(stepToDelete!);

    removeItem(steps, stepIndex);
    forceUpdate();
  }

  const filteredSteps = steps.filter((step) => !step.destroy);

  return (
    <>
      <ul className="approvals-page-drawer__list-steps">
        {filteredSteps.map((step, index) => {
          const positionNumber = getNumberPositionSufix(index + 1);

          return (
            <li key={getKey(step)} className="approvals-page-drawer__step">
              <Row>
                <Col span={4}>
                  <span className="approvals-page-drawer__step-label">
                    {positionNumber} Level
                  </span>
                </Col>
                <Col span={20}>
                  <ul className="approvals-page-drawer__lists sentry-mask">
                    <ApprovalsEditDrawerListApprovers
                      approverTemplates={step.approvalChainApproverTemplates}
                    />
                  </ul>
                </Col>
              </Row>
              {filteredSteps.length > 1 && (
                <ApprovalsEditDrawerDeleteButton
                  className="approvals-page-drawer__steps-delete-button"
                  tooltip={`Remove ${positionNumber} Level`}
                  disabled={preApproved}
                  onClick={() =>
                    removeStep(step?.id || '', step?.randomKey || '')
                  }
                />
              )}
              <Divider gutter={16} />
            </li>
          );
        })}
      </ul>
      <Button disabled={preApproved} onClick={addStep}>
        Add Level
      </Button>
      <style jsx>{`
        .approvals-page-drawer__list-steps {
          list-style: none;
          padding: 0;
          margin-bottom: 8px;
        }
        .approvals-page-drawer__step-label {
          vertical-align: sub;
        }
        .approvals-page-drawer__step {
          position: relative;
        }
        :global(.approvals-page-drawer__steps-delete-button) {
          margin-right: -16px;
          margin-top: -16px;
        }
      `}</style>
    </>
  );
};
